import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { combineLatest, of } from '@polkadot/x-rxjs';
import { map, take } from '@polkadot/x-rxjs/operators'; // the order and types needs to map with the all array setup below

function mapCapabilities(_ref) {
  var _ref2 = _slicedToArray(_ref, 3),
      systemRefcount32 = _ref2[0],
      systemRefcountDual = _ref2[1],
      stakingVersion = _ref2[2];

  var types = {}; // AccountInfo

  if (systemRefcountDual && systemRefcountDual.isTrue) {
    types.AccountInfo = 'AccountInfoWithProviders';
  } else if (systemRefcount32 && systemRefcount32.isTrue) {
    types.AccountInfo = 'AccountInfoWithRefCount';
  } // ValidatorPrefs


  if (stakingVersion) {
    if (stakingVersion.index >= 4) {
      // v1 = index 0, V5 = index 4
      types.ValidatorPrefs = 'ValidatorPrefsWithBlocked';
    } else {
      types.ValidatorPrefs = 'ValidatorPrefsWithCommission';
    }
  }

  return types;
}
/**
 * @description Query the chain for the specific capabilities
 */


export function detectedCapabilities(api, blockHash) {
  var _api$query$system, _api$query$system2, _api$query$staking;

  var all = [(_api$query$system = api.query.system) === null || _api$query$system === void 0 ? void 0 : _api$query$system.upgradedToU32RefCount, (_api$query$system2 = api.query.system) === null || _api$query$system2 === void 0 ? void 0 : _api$query$system2.upgradedToDualRefCount, (_api$query$staking = api.query.staking) === null || _api$query$staking === void 0 ? void 0 : _api$query$staking.storageVersion];
  var included = all.map(function (c) {
    return !!c;
  });
  var filtered = all.filter(function (_, index) {
    return included[index];
  });
  return (filtered.length ? blockHash ? combineLatest(filtered.map(function (c) {
    return c.at(blockHash);
  })) : api.queryMulti(filtered) : of([])).pipe(map(function (results) {
    var offset = -1;
    return mapCapabilities(included.map(function (isIncluded) {
      return isIncluded ? results[++offset] : null;
    }));
  }), take(1));
}